import type { Environment } from '@change-corgi/core/environment';

export const typesenseConfig: Record<Environment, { host: string; apiKey: string }> = {
	staging: {
		host: 'www.staging-change.org',
		apiKey:
			'UEdxT0d4RUZDVEx4YzB3M0FSVGhEYkNHMTR5N3Azd2JkTWhJbFExRDBicz03Q1FCeyJmaWx0ZXJfYnkiOiJkaXNjb3ZlcmFibGU6dHJ1ZSJ9',
	},
	production: {
		host: 'www.change.org',
		apiKey: 'xyz',
	},
	demo: {
		host: 'www.staging-change.org',
		apiKey:
			'UEdxT0d4RUZDVEx4YzB3M0FSVGhEYkNHMTR5N3Azd2JkTWhJbFExRDBicz03Q1FCeyJmaWx0ZXJfYnkiOiJkaXNjb3ZlcmFibGU6dHJ1ZSJ9',
	},
	development: {
		host: 'www.staging-change.org',
		apiKey:
			'UEdxT0d4RUZDVEx4YzB3M0FSVGhEYkNHMTR5N3Azd2JkTWhJbFExRDBicz03Q1FCeyJmaWx0ZXJfYnkiOiJkaXNjb3ZlcmFibGU6dHJ1ZSJ9',
	},
};
